import { render, staticRenderFns } from "./PbUpload.vue?vue&type=template&id=10690388&"
import script from "./PbUpload.vue?vue&type=script&lang=js&"
export * from "./PbUpload.vue?vue&type=script&lang=js&"
import style0 from "./PbUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports